module.exports = __webpack_public_path__ + "static/media/2012_Earthquakes_Mag5.5134f952.kml";